import { Logger } from './logger';
import { ExtraInfoProcess, Monitor } from './monitor';
import { GetAvgDelta } from './type';
import { CustomSlardarWebMonitor } from './customSlardarWebMonitor';

export { default as logger, setLoggerLevel } from './logger';
export {
  default as monitor,
  setMonitorEngine,
  setMonitorLevel,
} from './monitor';
export type { ExtraInfo } from './monitor';
export { LoggerLevel } from './type';
export type { LoggerLevelKey } from './type';
export type { HttpPayload } from '@slardar/web';

export { Monitor, Logger, CustomSlardarWebMonitor };
export type { ExtraInfoProcess };

export class MetricsConstructor {
  monitor!: Monitor;
  logger!: Logger;

  constructor(
    name: string,
    extraInfoProcess?: ExtraInfoProcess,
    getAvgDelta?: GetAvgDelta,
  ) {
    const monitor = new Monitor(name, extraInfoProcess, getAvgDelta);
    const logger = new Logger(name, monitor);
    return {
      monitor,
      logger,
    } as { monitor: Monitor; logger: Logger };
  }
}
